<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <v-list>
                <v-list-item
                    v-for="(other, oi) in other_conversations"
                    :key="oi"
                    v-on:click="onClickConversationChip(other)"
                >
                    <v-list-item-content
                    >
                        {{other.conversation_label}} ({{age(other.last_message_time)}})
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>


            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

const Time = require('@/js/time.js');
const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,
            title: 'Other Conversations',
            other_conversations: [],
        }
    },

    methods: {

        showDialog(title, other_conversations)
        {   
            this.title = title;
            this.other_conversations = other_conversations;

            /*if ( other_conversations.length == 1 )
            {
                this.onClickConversationChip(other_conversations[0]);
                return;
            }*/

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

        age(time)
        {
            return Time.getHumanReadableAge(time);
        },

        onClickConversationChip(other)
        {
             this.dialog = false;

             this.$rc.toHomeForEndpoint(this.$router, other.org_endpoint, false, other.conversation_id);
        },

    },
}
</script>

<style lang="scss" scoped>
</style>